module.exports = __webpack_public_path__ + "static/media/nolans.566e41fd.png";